import {useEffect, useRef, useState} from 'react';
import {SActionBtn, SBack, SLowcodeList, STableActions} from 'shj-components'
import config from './config.json';
import {billSetInfoListPage} from '@/services/integrationConfig'
export default function () {
  const listRef = useRef<any>();


  // 表格加载
  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query, ...rest } = values;
        billSetInfoListPage(current, pageSize, query).then(data => {
          resolve(data)
        })
      } catch (e) {
        console.log(e);
        reject({ success: false });
      }
    });
  };



  const extension = {
    request: { fetchList },
    events: {},
    customRender: {},
  };

  return <>
    <SBack title={`金蝶账套配置`} level={2} type="title">
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
    </SBack>
  </>
}
